module.exports = __webpack_public_path__ + "img/logo.68e4d6cc.png";